module.exports = __webpack_public_path__ + "static/media/Icons_regenerate_dark.89be252a.svg";